<form [formGroup]="form">
  <div class="status-codes-additional-details-container">
    <mat-form-field appearance="outline" class="mat-md full-height-textarea">
      <mat-label>Notes</mat-label>
      <textarea
        appTrimInput
        matInput
        formControlName="notes"
        rows="2"
        formControlName="notes">
      </textarea>
    </mat-form-field>
  </div>
</form>
